export enum FineTypeEnum {
    HOURLY = 'hourly',
    FORFAIT = 'inclusive',
    NONE = 'none',
}
